import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-zuzhiguanli-h",
  "use": "icon-zuzhiguanli-h-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" id=\"icon-zuzhiguanli-h\">\n  <rect x=\"4\" y=\"4\" width=\"16\" height=\"16\" rx=\"2\" ry=\"2\" />\n  <rect x=\"9\" y=\"9\" width=\"6\" height=\"6\" />\n  <line x1=\"9\" y1=\"1\" x2=\"9\" y2=\"4\" />\n  <line x1=\"15\" y1=\"1\" x2=\"15\" y2=\"4\" />\n  <line x1=\"9\" y1=\"20\" x2=\"9\" y2=\"23\" />\n  <line x1=\"15\" y1=\"20\" x2=\"15\" y2=\"23\" />\n  <line x1=\"20\" y1=\"9\" x2=\"23\" y2=\"9\" />\n  <line x1=\"20\" y1=\"14\" x2=\"23\" y2=\"14\" />\n  <line x1=\"1\" y1=\"9\" x2=\"4\" y2=\"9\" />\n  <line x1=\"1\" y1=\"14\" x2=\"4\" y2=\"14\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/zuzhiguanli-h.svg
// module id = OsjM
// module chunks = 96